// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2_vcw","modalForm":"UpgradeEpcsModal_modalForm__29yDK","modalFooter":"UpgradeEpcsModal_modalFooter__3XZBA"};